import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal" }
const _hoisted_2 = { class: "mb-2 d-flex justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.hasFilters)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary btn-sm me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
            }, _toDisplayString(_ctx.$t('modules.users.clear_filters')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "btn btn-success btn-sm",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args)))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-plus" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('modules.users.new_head')), 1)
      ])
    ]),
    _createVNode(_component_DxDataGrid, {
      ref: _ctx.gridRef,
      "data-source": _ctx.store,
      "hover-state-enabled": true,
      "remote-operations": true,
      "column-auto-width": true,
      "show-borders": true,
      scrolling: _ctx.scrollingConfig,
      onOptionChanged: _ctx.detectFilters
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxHeaderFilter, { visible: true }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, { "page-size": 10 }),
        _createVNode(_component_DxPager, {
          "show-info": true,
          "show-navigation-buttons": true,
          visible: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "name",
          caption: _ctx.$t('modules.users.name')
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, {
          "data-field": "surname",
          caption: _ctx.$t('modules.users.surname')
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, {
          "data-field": "email",
          caption: _ctx.$t('modules.users.email')
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, {
          caption: _ctx.$t('modules.users.roles'),
          "calculate-cell-value": row =>
          row.roles
            ?.map(r => this.$t(`modules.users.user_roles.${r}`))
            .join(', ')
        
        }, null, 8, ["caption", "calculate-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "phone",
          caption: _ctx.$t('modules.users.phone')
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, {
          "data-field": "driver_card",
          caption: _ctx.$t('modules.users.driver_card')
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, {
          caption: _ctx.$t('modules.users.driver_card_validity'),
          "calculate-cell-value": _ctx.formatDriverCardValidity
        }, null, 8, ["caption", "calculate-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "active",
          caption: _ctx.$t('modules.users.active'),
          "data-type": "boolean"
        }, null, 8, ["caption"]),
        _createVNode(_component_DxColumn, { type: "buttons" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxButton, {
              icon: "edit",
              onClick: _ctx.edit
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              icon: "remove",
              onClick: _ctx.remove
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "scrolling", "onOptionChanged"])
  ]))
}